module.exports = __webpack_public_path__ + "img/chat_emoticon_tipos_23.png?3e0aabdd0d560e78a45ad0f79dcfa9ae";